import { queryOptions, useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import type { QueryConfig } from '@/lib/react-query';
import type { Court } from '@/types/api';

export const getCourt = ({
  courtId,
}: {
  courtId: string;
}): Promise<{ court: Court }> => {
  return api.get(`/scoreboard/v1/courts/${courtId}`);
};

export const getCourtQueryOptions = (courtId: string) => {
  return queryOptions({
    queryKey: ['courts', courtId],
    queryFn: () => getCourt({ courtId }),
  });
};

type UseCourtsQueryOptions = {
  courtId: string;
  queryConfig?: QueryConfig<typeof getCourtQueryOptions>;
};

export const useCourt = ({ courtId, queryConfig }: UseCourtsQueryOptions) => {
  return useQuery({
    ...getCourtQueryOptions(courtId),
    ...queryConfig,
  });
};
